
import { Component, Vue } from 'vue-property-decorator'
import AdminRoleService from '@/biz/service/User/AdminRoleService'
import RouterService from '@/service/RouterService'
import ValidateService from '@/service/ValidateService'

@Component
export default class ViewUserAdminPositionForm extends Vue {
  private Service = AdminRoleService

  private form = {
    id: RouterService.query('id'),
    display_name: ''
  }

  private formFields = ValidateService.genRules({
    display_name: {
      prop: 'display_name',
      label: '名称',
      rule: [ValidateService.required, ValidateService.max(30)]
    }
  })
}
